(function (window, angular) {
    'use strict';

    var app = angular.module('app');

    /**
     *
     * task App Controller
     *
     */
    app.controller('taskController',
        ['$scope', 'taskService', 'userService', '$filter', '$timeout', '$window', 'configService',
            function ($scope, taskService, userService, $filter, $timeout, $window, configService) {
                $scope.users = {};
                $scope.tasks = []; // all current tasks
                $scope.filters = {};
                $scope.pager = {
                    current_page: 1,
                    total: 0,
                    last_page: 0
                };

                /**
                 * init controller
                 * @return {none}
                 */
                $scope.init = function () {

                    $scope.filters = {
                        for_user: {
                            id: configService.uid
                        },
                        status: 'todo',
                    };

                    $scope.loading = true;
                    userService.search().then(function (users) {
                        $scope.users = {
                            array: users,
                        };
                        angular.forEach(users, function (user, idx) {
                            $scope.users['id' + user.id] = user;
                        });

                        $scope.search();
                    });
                }

                $scope.getUser = function (user_id) {
                    return $scope.users['id' + user_id];
                }

                /**
                 * search for tasks
                 * @return none
                 */
                $scope.search = function () {
                    $scope.loading = true;

                    if ($scope.filters.for_user) {
                        $scope.filters.for_user_id = $scope.filters.for_user.id;
                    }
                    else {
                        delete($scope.filters.for_user_id);
                    }

                    if ($scope.filters.owner) {
                        $scope.filters.owner_user_id = $scope.filters.owner.id;
                    }
                    else {
                        delete($scope.filters.owner_user_id);
                    }

                    taskService.search($scope.filters, $scope.pager.current_page).then(function (result) {
                        $scope.tasks = result.data;
                        angular.forEach($scope.tasks, function (task, idx) {
                            $scope.initTask(task, $scope.filters);
                        });
                        $scope.pager = result;
                        $scope.indicators = result.extra;

                        $scope.loading = false;
                    }, function (error) {
                        $scope.loading = false;
                    });
                }

                /**
                 * Add some usefull info for the view
                 */
                $scope.initTask = function (task, filters) {
                    task.is_delegated_to_myself = false;
                    angular.forEach(task.users, function (user, idx) {
                        if (user.id == configService.uid) {
                            task.is_delegated_to_myself = true;
                        }
                    });
                    task.is_mine = task.user_id == configService.uid; // am i the owner ?
                    task.status_finished = task.is_mine ? 'closed' : 'done'; // finished at my level owner or delegate
                    task.is_done_or_closed = task.status == task.status_finished;
                    task.can_change_status = task.is_mine || task.is_delegated_to_myself;
                    task.is_waiting_for_approval = task.status == 'done' && task.is_mine;
                    task.user = $scope.getUser(task.user_id);

                    if (filters.search) {
                        var highlighted = task.title;
                        highlighted = highlighted.replace(new RegExp('(' + filters.search + ')', 'gi'),
                            '<span class="highlighted">$1</span>');
                        task.title = highlighted;
                    }

                    return task;
                }

                /**
                 * toggle task status
                 * @param  {object} task to modify
                 * @return {none}
                 */
                $scope.toggleTaskStatus = function (task) {
                    // check whether we know this task
                    var idx = $scope.tasks.indexOf(task);
                    if (idx == -1) {
                        return;
                    }

                    // update the status
                    task.status = task.status == task.status_finished ? 'todo' : task.status_finished;

                    task.loading = true;
                    taskService.save(task).then(function (updated_task) {
                        $scope.initTask(updated_task);
                        task.loading = false;

                        menuTasksCount();
                    }, function (error) {
                        task.loading = false;
                    });
                }

                $scope.toggleFilterPriority = function (priority) {
                    if ($scope.filters.priority == priority) {
                        delete($scope.filters.priority);
                    }
                    else {
                        $scope.filters.priority = priority;
                    }

                    $scope.search();
                }

                $scope.toggleFilterDueDate = function (due_date) {
                    // if( $scope.filters.due_date == due_date ) {
                    //     delete($scope.filters.due_date);
                    // }
                    // else {
                    $scope.filters.due_date = due_date;
                    // }

                    $scope.search();
                }

                /**
                 * Delete a task !
                 * @param  {object} task to delete
                 * @return {none}
                 */
                $scope.deleteTask = function (task) {
                    // check whether we know this task
                    var idx = $scope.tasks.indexOf(task);
                    if (idx == -1 || !task.is_mine) {
                        return;
                    }

                    taskService.delete(task).then(function () {
                        $scope.tasks.splice(idx, 1);
                        menuTasksCount();
                    });
                }

                $scope.scopeFilterChanged = function () {
                    if ($scope.filters.scope === null) {
                        delete($scope.filters.scope);
                    }
                    else if ($scope.filters.scope == 'my_tasks') {
                        delete($scope.filters.owner);
                        delete($scope.filters.for_user);
                    }
                    else if ($scope.filters.scope == 'tasks_to_monitor') {
                        delete($scope.filters.owner);
                    }

                    $scope.search();
                }

                $scope.ownerFilterChanged = function () {
                    if ($scope.filters.owner) {
                        delete($scope.filters.scope);
                    }

                    $scope.search();
                }

                $scope.forUserFilterChanged = function () {
                    if ($scope.filters.for_user) {
                        if ($scope.filters.scope == 'my_tasks') {
                            delete($scope.filters.scope);
                        }
                    }

                    $scope.search();
                }

                $scope.editTask = function (task) {
                    $window.location = '/task/' + task.id;
                }

            }
        ])
    ;

})
(window, window.angular);
